/**
 * Copyright (c) 2017-present, Tomaruba, Inc.
 * All rights reserved.
 *
 */

//@params opts = { apiCall, onSucceded, onFailed, onError }
//To prevent this will be undefined in the api call, all paramters should be callback functions
//Example () => hogeApi.doSometihng(apiParams)
export default function ApiHandle(opts) {
  opts.apiCall
    .call()
    .then(response => {
      //if (response.status === 'ok')
      opts.onSucceded(response)
      //else opts.onFailed(response);
    })
    .catch(error => {
      opts.onErrored(error)
    })
}
